import { USER_GROUP_KEY } from '@loc/helpers/src/userGroup'

import { useCookieDomain } from '../cookieDomain'

import { setCookie } from '@/helpers/cookies.browser'

export function useCookieUserGroup() {
  const { cookieDomainRef } = useCookieDomain()

  function updateCookieUserGroup(group: string) {
    setCookie(USER_GROUP_KEY, group, {
      maxAge: 20 * 365 * 24 * 60 * 60 * 1000,
      path: '/',
      domain: cookieDomainRef.current,
    })
  }

  return {
    updateCookieUserGroup,
  }
}
